/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response object for an institute room badge
 * @export
 * @interface InstituteRoomBadge
 */
export interface InstituteRoomBadge {
    /**
     * Unique identifier of the room badge.
     * @type {string}
     * @memberof InstituteRoomBadge
     */
    uuid?: string;
    /**
     * State of the color
     * @type {boolean}
     * @memberof InstituteRoomBadge
     */
    active?: boolean;
    /**
     * Color of the badge
     * @type {string}
     * @memberof InstituteRoomBadge
     */
    color?: string;
    /**
     * Text in the badge
     * @type {string}
     * @memberof InstituteRoomBadge
     */
    text?: string;
}

/**
 * Check if a given object implements the InstituteRoomBadge interface.
 */
export function instanceOfInstituteRoomBadge(value: object): value is InstituteRoomBadge {
    return true;
}

export function InstituteRoomBadgeFromJSON(json: any): InstituteRoomBadge {
    return InstituteRoomBadgeFromJSONTyped(json, false);
}

export function InstituteRoomBadgeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstituteRoomBadge {
    if (json == null) {
        return json;
    }
    return {
        
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'active': json['active'] == null ? undefined : json['active'],
        'color': json['color'] == null ? undefined : json['color'],
        'text': json['text'] == null ? undefined : json['text'],
    };
}

export function InstituteRoomBadgeToJSON(json: any): InstituteRoomBadge {
    return InstituteRoomBadgeToJSONTyped(json, false);
}

export function InstituteRoomBadgeToJSONTyped(value?: InstituteRoomBadge | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uuid': value['uuid'],
        'active': value['active'],
        'color': value['color'],
        'text': value['text'],
    };
}

